/**
 * Game Zone Service
 * Migrated from 3in1cms legacy/gameZoneApi.ts
 */

import { request } from "../core/request";
import { OPERATION_IDS } from "./constants";
import { createCacheAsync } from "@repo/shared-utils/cache";
import type { IGame, TApiResponseGameData, TApiGameDataRequestBody } from "../types/gameZoneTypes";

/**
 * Get user game data (favorites and continue playing)
 * @param mobileNo - User mobile number
 * @returns Game data response or null
 */
export const getUserGameData = async (mobileNo: string): Promise<TApiResponseGameData | null> => {
  try {
    const response = (await createCacheAsync(
      `myzoneRead-${mobileNo}`,
      async () =>
        await request<TApiResponseGameData, TApiGameDataRequestBody>({
          operationId: OPERATION_IDS.favCpRead,
          requestData: {
            mobileNo,
          },
        })
    )) as TApiResponseGameData;

    if (response.favorites) {
      const favorite = response.favorites;
      for (const key of Object.keys(favorite)) {
        if (response.favorites[key]) {
          response.favorites[key].favFlag = true;
        }
      }
    }
    return response;
  } catch (error) {
    console.error("Error in getUserGameData", error);
    return null;
  }
};

/**
 * Insert or update user game data (favorites and continue playing)
 * @param mobileNo - User mobile number
 * @param favouriteGamesList - List of favorite games
 * @param continuePlayingGamesList - List of continue playing games
 */
export const insertUserGameData = async ({
  mobileNo,
  favouriteGamesList,
  continuePlayingGamesList,
}: {
  mobileNo: string;
  favouriteGamesList?: IGame[];
  continuePlayingGamesList?: IGame[];
}): Promise<void> => {
  try {
    let favList: Record<string, IGame> = {};
    for (const game of favouriteGamesList || []) {
      if (game.gameId) {
        favList = {
          ...favList,
          [game.gameId]: game,
        };
      }
    }
    let continuePlayingList: Record<string, IGame> = {};
    for (const game of continuePlayingGamesList || []) {
      if (game.gameId) {
        continuePlayingList = {
          ...continuePlayingList,
          [game.gameId]: {
            ...game,
            cpFlag: true,
          },
        };
      }
    }

    await request({
      operationId: OPERATION_IDS.favCpInsert,
      requestData: {
        mobileNo,
        favorites: favList,
        continuePlaying: continuePlayingList,
      },
    });
  } catch (error) {
    console.error("Error in updating favourites", error);
    throw error;
  }
};
